export type ReportModel = 'LR' | 'NP' | 'PR' | 'IMP_EXP' | 'FR';

export const REPORT_MODEL_MAP: Record<string, ReportModel> = {
  'earnings-by-divisions': 'LR',
  'test-count-by-divisions': 'LR',
  'sample-count-by-divisions': 'LR',
  'item-qty-by-divisions': 'LR',
  'earnings-by-divisions-nom-pay': 'NP',
  'test-count-by-divisions-nom-pay': 'NP',
  'pr-earnings-by-departments': 'PR',
  'pr-count-by-departments': 'PR',
  'registrations-by-establishment': 'PR',
  'imp-exp-earnings-by-departments': 'IMP_EXP',
  'imp-exp-count-by-departments': 'IMP_EXP',
  'imp-exp-earnings-comparison': 'IMP_EXP',
  'imp-exp-counts-comparison': 'IMP_EXP',
  'imp-exp-nominal-earnings': 'IMP_EXP',
  'imp-exp-nominal-count': 'IMP_EXP',
  'imp-exp-levels-by-qty': 'IMP_EXP',
  'consignment-by-country': 'IMP_EXP',
  'imp-exp-tonnage': 'IMP_EXP',
  'h-form': 'FR',
  'summary-report': 'FR',
  'cashier-point-summary': 'FR',
};
